(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
  })();
  (function() {
  if (!__sections__["bgimgttl-prodlst"] && !window.DesignMode) return;
  try {
    
  var sw = '.bgimgttl-prodlst__lst';
  var swArea = document.querySelectorAll(sw);

  for (let i = 0; i < swArea.length; i++){ 
    var prevTag = document.createElement('div'); 
    prevTag.className = 'sw_prev';
    prevTag.innerHTML = '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#inarrow"></use></svg>';
    var nextTag = document.createElement('div'); 
    nextTag.className = 'sw_next';
    nextTag.innerHTML = '<svg><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#inarrow"></use></svg>';
    
    var swTag = document.createElement('div'); 
    swTag.className = 'sw_control';
    swTag.appendChild(prevTag);
    swTag.appendChild(nextTag);
    swArea[i].appendChild(swTag);
  }
    
  var proSwiper = new Swiper(sw, {
    speed: 1000,
    slidesPerView: 1.3,
    spaceBetween: 15,
    breakpoints: {
      450: {
        slidesPerView:1.8,
      },
      650: {
        slidesPerView:2.5,
      },
      750: {
        slidesPerView:1.5,
        spaceBetween: 20
      },
      990: {
        slidesPerView: 1.8,
        spaceBetween: 30
      },
      1400: {
        slidesPerView: 2.6,
        spaceBetween: 50
      }
    },
    navigation: {
      prevEl: '.sw_prev',
      nextEl: '.sw_next'
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mv"]) return;
  try {
    
//MVページャーアニメ
var line;
function pjAnime(i){
var dot = document.getElementsByClassName('sw-p_line');
  line = 314;
  let animation = setInterval(function(){
    dot[i].setAttribute('stroke-dashoffset', line);
    line--;
    if (line < 0) {
      clearInterval(animation);
    }
  }, 19);
}
  
//MVスライド
var mv = '.t-mv .swiper';
var mvArea = document.querySelectorAll(mv);
var pgTag = document.createElement('div'); 
pgTag.className = 'sw-pager';

for (let i = 0; i < mvArea.length; i++){
  mvArea[i].appendChild(pgTag);
}

var mvSwiper = new Swiper(mv, {
  loop: true,
  effect: 'fade', 
  fadeEffect: {
    crossFade: true
  },
  speed: 500,
  autoplay: { 
    delay: 6000,
    disableOnInteraction: false
  },
  pagination: {
    el: '.sw-pager',
    clickable: true,
    renderBullet: (index, className) => {
      return '<span class="' + className + '"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 110 110"><circle cx="55" cy="55" r="50" class="sw-p_line" /></svg></span>';
    },
  },
  on: {
    slideChange : (swiper) => {
      pjAnime(swiper.realIndex);
    }
  }
});

  } catch(e) { console.error(e); }
})();

})();
